import React from 'react';
import { ReactComponent as PlayIcon } from '../../play-icon.svg';

interface PlayButtonProps {
  cardType: 'video' | 'module' | 'assessment';
}

export default function PlayButton({ cardType }: PlayButtonProps) {
  return cardType === 'video' || cardType === 'assessment' ? (
    <div className="play-btn">
      <PlayIcon className="custom-icon hero-icon-18" />
    </div>
  ) : null;
}
